import { render, staticRenderFns } from "./ViewAddedRevenuePage.vue?vue&type=template&id=400cd2a6"
import script from "./ViewAddedRevenuePage.vue?vue&type=script&lang=js"
export * from "./ViewAddedRevenuePage.vue?vue&type=script&lang=js"
import style0 from "./ViewAddedRevenuePage.vue?vue&type=style&index=0&id=400cd2a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports